import { ThemeProvider, Typography, withStyles } from "@material-ui/core";

import QRCode from "qrcode.react";
import React from "react";
import { theme } from "../constants/theme";
import tradeKartIcon from "../assets/icons/tradeKartIcon.svg";
type Props = {
  data: any;
  ref: any;
  classes: any;
  qrData: any;
};
class QRPrintableComponent extends React.PureComponent<Props> {
  render() {
    const { classes, data } = this.props;
    const qrCodeData = this.props.qrData?.Packages;
    return (
      <div className="container" style={{ margin: "0", padding: "0" }}>
        {qrCodeData !== undefined ? (
          qrCodeData.map((item: any) => (
            <div key={item.PackageNo} className={classes.container}>
              <ThemeProvider theme={theme}>
                <div className={classes.innerContainer}>
                  <div className={classes.header}>
                    <img
                      src={tradeKartIcon}
                      className={classes.tradeKartIcon}
                      alt="TradeKart"
                    />
                    <Typography variant="subtitle1" component="p">
                      TradeKart
                    </Typography>
                  </div>
                  <div className={classes.customerInfoContainer}>
                    <Typography
                      variant="caption"
                      component="p"
                      style={{ textDecoration: "underline" }}
                    >
                      Order No:
                    </Typography>
                    <Typography
                      variant="caption"
                      component="p"
                      style={{ paddingLeft: "3mm" }}
                    >
                      {data.OrderNo}
                    </Typography>
                  </div>
                  <div className={classes.customerInfoContainer}>
                    <Typography
                      variant="caption"
                      component="p"
                      style={{ textDecoration: "underline" }}
                    >
                      Package No:
                    </Typography>
                    <Typography
                      variant="caption"
                      component="p"
                      style={{ paddingLeft: "3mm" }}
                    >
                      {item.PackageNo}
                    </Typography>
                  </div>
                  <div className={classes.customerInfoContainer}>
                    <Typography
                      variant="caption"
                      component="p"
                      style={{ textDecoration: "underline" }}
                    >
                      Name:
                    </Typography>
                    <Typography
                      variant="caption"
                      component="p"
                      style={{ paddingLeft: "3mm" }}
                    >
                      {data.CustomerFirstName + " " + data.CustomerLastName}
                    </Typography>
                  </div>
                  <div className={classes.customerInfoContainer}>
                    <Typography
                      variant="caption"
                      component="p"
                      style={{ textDecoration: "underline" }}
                    >
                      Address:
                    </Typography>
                    <Typography
                      variant="caption"
                      component="p"
                      style={{ paddingLeft: "3mm" }}
                    >
                      {(data.DeliveryAddressLine1 === null
                        ? ""
                        : data.DeliveryAddressLine1) +
                        " " +
                        (data.DeliveryAddressLine2 === null
                          ? ""
                          : data.DeliveryAddressLine2) +
                        " " +
                        (data.DeliveryAddressLine3 === null
                          ? ""
                          : data.DeliveryAddressLine3) +
                        ", " +
                        data.DeliveryAddressPostCode +
                        ", " +
                        data.DeliveryAddressCounty +
                        " " +
                        data.DeliveryAddressCity}
                    </Typography>
                  </div>
                  <div className={classes.qrContainer}>
                    <QRCode
                      value={item.Barcode}
                      size={80}
                      bgColor={"#ffffff"}
                      fgColor={"#000000"}
                      level={"L"}
                      includeMargin={false}
                      renderAs={"svg"}
                      /* imageSettings={{
                      src: "https://static.zpao.com/favicon.png",
                      x: undefined,
                      y: undefined,
                      height: 24,
                      width: 24,
                      excavate: true,
                    }} */
                    />
                  </div>
                </div>
              </ThemeProvider>
            </div>
          ))
        ) : (
          <></>
        )}
      </div>
    );
  }
}

const styles = (theme: any) => ({
  qrContainer: {
    justifyContent: "center",
    paddingTop: "0mm",
    alignItems: "center",
    display: "flex",
    height: "50%",
  },
  customerInfoContainer: {
    marginTop: "3mm",
    display: "flex",
    paddingLeft: "3mm",
    paddingRight: "3mm",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  container: {
    height: "100vh",
    padding: "2mm",
    border: "1px solid black",
  },
  innerContainer: {
    border: "1px solid black",
    height: "100%",
    borderRadius: "10px",
  },
  header: {
    paddingLeft: "2mm",
    paddingTop: "1mm",
    display: "flex",
  },
  tradeKartIcon: {
    width: "5mm",
    height: "5mm",
    borderRadius: "1px",
    marginRight: "1mm",
  },
});
export default withStyles(styles)(QRPrintableComponent);
